import { IGlobalState } from '../../../Root/store/appReducer'

// List of all SSO configs for selected company
export const getSsoConfigs = (state: IGlobalState) => state.ssoAdmin?.configs
// Currently selected config (detail view)
export const getSelectedSsoConfig = (state: IGlobalState) => state.ssoAdmin?.selectedConfig
export const getSsoLoading = (state: IGlobalState) => state.ssoAdmin?.loading
export const getSsoSaving = (state: IGlobalState) => state.ssoAdmin?.saving
export const getSsoDeleting = (state: IGlobalState) => state.ssoAdmin?.deleting
export const getCreatedConfigId = (state: IGlobalState) => state.ssoAdmin?.createdConfigId
// SCIM
export const getScimConfig = (state: IGlobalState) => state.ssoAdmin?.scimConfig
export const getScimTokenVisible = (state: IGlobalState) => state.ssoAdmin?.scimTokenVisible
export const getScimSaving = (state: IGlobalState) => state.ssoAdmin?.scimSaving
// Company-level SSO settings
export const getSsoRequired = (state: IGlobalState) => state.ssoAdmin?.ssoRequired
export const getSsoSettingsLoading = (state: IGlobalState) => state.ssoAdmin?.ssoSettingsLoading
export const getSsoSettingsUpdating = (state: IGlobalState) => state.ssoAdmin?.ssoSettingsUpdating
